/**
 * Где сработало оповещение колокольчика: кампания и группа из снимка в
 * payload (бэкенд пишет их в момент срабатывания, `user_alerts.with_location`).
 * Нет имени кампании — строки нет вовсе: у старого оповещения, которое
 * восстановить не удалось, не должно появиться «undefined» или прочерка.
 */

export type AlertLocation = {
  campaignName: string;
  /** Путь внутри организации (без public_id), null — ссылки нет. */
  campaignHref: string | null;
  adGroupName: string | null;
  adGroupHref: string | null;
};

const PLACEHOLDERS = new Set(["undefined", "null", "none", "—", "-"]);

function cleanName(v: unknown): string | null {
  if (typeof v !== "string") return null;
  const t = v.trim();
  return t && !PLACEHOLDERS.has(t.toLowerCase()) ? t : null;
}

function positiveId(v: unknown): number | null {
  const n =
    typeof v === "number" ? v : typeof v === "string" && /^\d+$/.test(v.trim()) ? Number(v) : NaN;
  return Number.isSafeInteger(n) && n > 0 ? n : null;
}

export function alertLocation(payload: Record<string, unknown>): AlertLocation | null {
  const campaignName = cleanName(payload.campaign_name);
  if (campaignName === null) return null;
  const campaignId = positiveId(payload.campaign_id);
  const adGroupName = cleanName(payload.ad_group_name);
  const adGroupId = positiveId(payload.ad_group_id);
  let adGroupHref: string | null = null;
  if (campaignId !== null && adGroupId !== null && adGroupName !== null) {
    const q = new URLSearchParams({
      tab: "keywords",
      ad_group: String(adGroupId),
      ad_group_name: adGroupName,
    });
    adGroupHref = `/ads/campaigns/${campaignId}?${q.toString()}`;
  }
  return {
    campaignName,
    campaignHref: campaignId !== null ? `/ads/campaigns/${campaignId}` : null,
    adGroupName,
    adGroupHref,
  };
}
